import { fetchJSON } from "./utils";

export async function fetchAll(params = null) {
  const url = `/api/unit/`;
  return fetchJSON(url, params, null, "get", false);
}

export async function createUnit(data) {
  const url = `/api/unit/`;
  return fetchJSON(url, null, data, "post");
}

export function createBulkUsers(data) {
  const url = "/api/unit/create_bulk_full";
  return fetchJSON(url, null, data, "post");
}

export async function updateUnit(id, data) {
  const url = `/api/unit/${id}`;
  return fetchJSON(url, null, data, "put");
}

export async function deleteUnit(id) {
  const url = `/api/unit/${id}`;
  return fetchJSON(url, null, null, "delete");
}
